import React, { Component } from "react";
import { connect } from "react-redux";
import MsaWarning from "../ExtraComponents/MsaWarning";
import SettingsError from "../ExtraComponents/SettingsError";
import {
  getSingleRfqQuestion,
  editRfqQuestion,
  listQuestionGroup,
} from "./../../../config/reseller_api_calls";
import PageTitle from "../ExtraComponents/PageTitle";
import HelperClass from "./../../../config/helperClass";
import { addSettings, addMsaInfo } from "../../../actions";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { tableLoader } from "../../../components/ContentLoaders/table_loader";
import { Fileupload } from "../../../components/Image/Fileupload";
import Tooltip from "@material-ui/core/Tooltip";
import MutextField from "@material-ui/core/TextField";
import DataTable from "../../../components/Tables/DataTable";
import Typography from "@material-ui/core/Typography";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Link from "@material-ui/core/Link";
import HomeIcon from "@material-ui/icons/Home";
import RichTextEditorComponent from "../../../components/Reseller/RichTextEditorComponent";

const auth = new HelperClass();

class AddQuestionsLibrary extends Component {
  constructor() {
    super();
    this.state = {
      questionData: [],
      errorMessage: "",
      question_id: "",
      successMessage: "",
      SmtpErrorMessage: "",
      SmtpSuccessMessage: "",
      smtp_reg_button: false,
      smtp_test_button: false,
      waitMessage: "",
      tableLoader: true,
      signup_link: "",
      copied: false,
      copied2: false,
      cpied_value: "",
      current_id: "",
      reg_button: false,
      reg_button_login: false,
      cancel_button: false,
      tableLoader: true,
      login_url: "",
      logo: "",
      signature_image: "",
      smtp_host: "",
      smtp_user: "",
      smtp_password: "",
      smtp_method: "tls",
      smtp_port: "",
      errorHostName: "",
      errorUser: "",
      errorPassword: "",
      from_email: "",
      errorFromEmail: "",
      is_working: "",
      question_title: "",
      seqno: "",
      question_type: "",
      show_container: false,
      misc_rows: [],
      disabled: false,
      button_processing: false,
      question_groups: [],
      selected_group: "",
      isMandatory: 0,
      show_container_text: false,
    };
  }

  async componentDidMount() {
    let question_id = this.props.props.match.params.question_id;
    const servicesResponce = await getSingleRfqQuestion(
      auth.getAccount(),
      auth.getToken(),
      question_id
    );
    // console.log("getSingleRfqQuestion: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      //window.location.replace("/error");
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      // console.log("options: ", servicesResponce.data.data[0]["options"]);
      if (
        servicesResponce.data.data[0]["question_type"] === "checkbox" ||
        servicesResponce.data.data[0]["question_type"] === "radio" ||
        servicesResponce.data.data[0]["question_type"] === "dropdown"
      ) {
        this.setState({
          show_container: true,
          misc_rows: servicesResponce.data.data[0]["options"],
        });
      }
      if (servicesResponce.data.data[0]["question_type"] === "simple_text") {
        this.setState({
          show_container_text: true,
          misc_rows: [
            {
              question_options:
                servicesResponce.data.data[0]["options"][0]?.question_options ||
                "",
            },
          ],
        });
      }
      this.setState({
        questionData: servicesResponce.data.data,
        question_title: servicesResponce.data.data[0]["question_title"],
        seqno: servicesResponce.data.data[0]["seqno"],
        question_type: servicesResponce.data.data[0]["question_type"],
        question_id: question_id,
        selected_group: servicesResponce.data.data[0]["selectedGroup"],
        isMandatory: servicesResponce.data.data[0]["isMandatory"],
        tableLoader: false,
      });
    } else {
      // window.location.replace("/error");
    }
    const listGroupsResponse = await listQuestionGroup(
      auth.getAccount(),
      auth.getToken()
    );
    // console.log("listQuestionGroup: ", listGroupsResponse.data);
    if (
      listGroupsResponse.data.status === 403 ||
      listGroupsResponse.data.errors === "authentication missing" ||
      listGroupsResponse.data.errors === "jwt expired"
    ) {
      //auth.logout();
    } else if (listGroupsResponse.data.status === 404) {
      this.setState({
        errorMessage: "There is some error while getting Question Groups.",
        successMessage: "",
        button_processing: false,
      });
    } else if (
      listGroupsResponse.data.status === 200 &&
      listGroupsResponse.data.message === "success"
    ) {
      this.setState({
        errorMessage: "",
        question_groups: listGroupsResponse.data.data,
      });
    } else {
      this.setState({
        errorMessage: "There is some error while getting Question Groups.",
        successMessage: "",
        button_processing: false,
      });
    }
  }

  //Test SMTP Settings

  handleChange = async (event) => {
    const { target } = event;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const { name } = target;

    this.setState({
      [name]: value,
    });
  };

  validateIPAddress = (ipAddress) => {
    const ipRegex = /^(\d{1,3}\.){3}\d{1,3}$/;
    const isValid = ipRegex.test(ipAddress);
    //console.log(`Is IP Address valid? ${isValid}`);
    return isValid;
  };

  validateDomain = (domain) => {
    const domainRegex = /^[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const isValid = domainRegex.test(domain);
    //console.log(`Is domain valid? ${isValid}`);
    if (isValid) {
      return true;
    }
    return false;
  };

  validateEmailAdd = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const isValidEmail = emailRegex.test(email);
    //console.log("isValidEmail: " + " " + email + " = " + isValidEmail);
    if (isValidEmail) {
      return true;
    }
    return false;
  };

  addMenuHistory = (link) => {
    this.props.props.history.push(link);
  };

  editRfqQuestion = async () => {
    let {
      question_title,
      question_type,
      misc_rows,
      question_id,
      selected_group,
      isMandatory,
      seqno,
    } = this.state;
    this.setState({
      errorMessage: "",
      successMessage: "",
      button_processing: true,
    });
    var is_validated = true;
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
    if (question_title === "") {
      this.setState({
        errorMessage: "Question text is required.",
        button_processing: false,
      });
      is_validated = false;
    } else if (selected_group === "") {
      this.setState({
        errorMessage: "Question group is required.",
        button_processing: false,
      });
      is_validated = false;
    } else if (seqno === "") {
      this.setState({
        errorMessage: "Sequence number is required.",
        button_processing: false,
      });
      is_validated = false;
    }
    // console.log("misc_rows: ", misc_rows);
    if (is_validated) {
      // console.log("misc_rows: ", misc_rows);
      const servicesResponce = await editRfqQuestion(
        auth.getAccount(),
        auth.getToken(),
        question_title,
        question_type,
        question_id,
        misc_rows,
        selected_group,
        isMandatory,
        seqno
      );
      // console.log("editRfqQuestion: ", servicesResponce.data);

      if (
        servicesResponce.data.status === 403 ||
        servicesResponce.data.errors === "authentication missing" ||
        servicesResponce.data.errors === "jwt expired"
      ) {
        //auth.logout();
      } else if (
        servicesResponce.data.status === 404 &&
        servicesResponce.data.message === "not_found"
      ) {
        this.setState({
          errorMessage: "Question not found.",
          successMessage: "",
          button_processing: false,
        });
      } else if (
        servicesResponce.data.status === 200 &&
        servicesResponce.data.message === "success"
      ) {
        this.setState({
          errorMessage: "",
          successMessage: "Question updated successfully.",
          button_processing: false,
          is_working: "yes",
        });
        setTimeout(() => {
          this.props.props.history.push("/QuestionsLibrary");
        }, 3000);
      } else {
        this.setState({
          errorMessage: "There is some error while updating the RFQ question.",
          successMessage: "",
          button_processing: false,
        });
      }
    }
    setTimeout(() => {
      this.setState({ errorMessage: "", successMessage: "" });
    }, 5000);
  };

  handleEditorBank = (updatedContent) => {
    const misc_rows = [...this.state.misc_rows];
    misc_rows[0]["question_options"] = updatedContent;
    this.setState(
      {
        misc_rows,
        isBlocking: false,
      },
      () => {
        // console.log("Updated misc_rows:", this.state.misc_rows);
      }
    );
  };

  setMarkUp = async (event) => {
    const { target } = event;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const { name } = target;

    this.setState({
      [name]: value,
    });
    // console.log("name: " + name + " " + value);
    //if (value === "radio" || value === "checkbox" || value === "dropdown") {
    this.showAnswerContainer(value);
    //}
  };

  setQuestionGroup = async (event) => {
    const { target } = event;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const { name } = target;
    this.setState({
      selected_group: value,
    });
  };

  showAnswerContainer = (question_type) => {
    if (
      question_type === "radio" ||
      question_type === "checkbox" ||
      question_type === "dropdown"
    ) {
      this.setState({
        show_container: true,
      });
    } else {
      this.setState({
        show_container: false,
      });
    }

    if (question_type === "simple_text") {
      this.setState({
        show_container_text: true,
      });
    } else {
      this.setState({
        show_container_text: false,
      });
    }
  };

  handleChangeMisc = (idx) => (e) => {
    const { name, value } = e.target;
    const misc_rows = [...this.state.misc_rows];
    misc_rows[idx][name] = value;

    this.setState({
      misc_rows,
      isBlocking: false,
    });
  };

  handleAddRow = () => {
    const item = {
      question_options: "",
    };
    this.setState({
      misc_rows: [...this.state.misc_rows, item],
    });
  };

  handleRemoveRow = () => {
    this.setState({
      misc_rows: this.state.misc_rows.slice(0, -1),
    });
  };

  handleRemoveSpecificRow = (idx) => () => {
    const misc_rows = [...this.state.misc_rows];
    misc_rows.splice(idx, 1);
    this.setState({ misc_rows });
  };

  checkNumber = async (evt) => {
    var theEvent = evt || window.event;
    var key = theEvent.keyCode || theEvent.which;
    var keyCode = key;
    key = String.fromCharCode(key);
    if (key.length == 0) return;
    var regex = /^[0-9.\b ]+$/;
    if (keyCode == 188 || keyCode == 190) {
      return;
    } else {
      if (!regex.test(key)) {
        theEvent.returnValue = false;
        if (theEvent.preventDefault) theEvent.preventDefault();
      }
    }
  };

  render() {
    return (
      <div className="nk-content ">
        <div className="container-fluid">
          {/* MSA WARNING  START*/}
          {this.props.defaultSettings === "missing" ? <SettingsError /> : null}
          {this.props.is_msa_signed === "No" ? <MsaWarning /> : null}
          {/* MSA WARNING END */}
          <div className="nk-content-inner">
            <div className="nk-content-body">
              <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between">
                  <div className="nk-block-head-content">
                    <Breadcrumbs aria-label="breadcrumb">
                      <Link
                        color="inherit"
                        onClick={() => this.addMenuHistory("/")}
                        className=""
                        style={{
                          display: "flex",
                          alignItems: "center",
                          cursor: "pointer",
                        }}
                      >
                        <HomeIcon fontSize="inherit" className="" />
                        Home
                      </Link>
                      <Link
                        color="inherit"
                        onClick={() => this.addMenuHistory("/QuestionsLibrary")}
                        className=""
                        style={{
                          display: "flex",
                          alignItems: "center",
                          cursor: "pointer",
                        }}
                      >
                        Questions Library
                      </Link>
                      <Typography color="textPrimary" className="">
                        Edit RFQ Question
                      </Typography>
                    </Breadcrumbs>
                  </div>
                </div>
              </div>

              <div className="row g-gs">
                {/* Table 5th Col Start */}
                <div className="col-xxl-12">
                  <div className="nk-block nk-block-lg">
                    <div className="card card-bordered">
                      <div className="card-inner">
                        {this.state.errorMessage !== "" ? (
                          <div
                            className="example-alert"
                            style={{ marginBottom: "15px" }}
                          >
                            <div className="alert alert-pro alert-danger">
                              <div className="alert-text">
                                <h4>Error</h4>
                                <p>{this.state.errorMessage}</p>
                              </div>
                            </div>
                          </div>
                        ) : null}
                        {this.state.successMessage !== "" ? (
                          <div
                            className="example-alert"
                            style={{ marginBottom: "15px" }}
                          >
                            <div className="alert alert-pro alert-success">
                              <div className="alert-text">
                                <h4>Success</h4>
                                <p>{this.state.successMessage}</p>
                              </div>
                            </div>
                          </div>
                        ) : null}
                        <div className="row g-4">
                          <div className="col-md-12">
                            <div className="form-group">
                              <div className="form-label-group">
                                <label className="form-label">
                                  <Tooltip
                                    title="Request for quotation question."
                                    placement="right"
                                  >
                                    <em
                                      className="icon ni ni-info"
                                      style={{
                                        color: "#6576ff",
                                      }}
                                    ></em>
                                  </Tooltip>{" "}
                                  Question Text{" "}
                                  <span className="text-danger">*</span>
                                </label>
                              </div>
                              <div className="form-control-group">
                                <MutextField
                                  required
                                  id="question_title"
                                  name="question_title"
                                  type="text"
                                  label="Question Text"
                                  value={this.state.question_title}
                                  onChange={this.handleChange}
                                  variant="outlined"
                                  fullWidth
                                autoComplete="new-password"
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group">
                              <div className="form-label-group">
                                <label className="form-label">
                                  <Tooltip
                                    title="Request for quotation answer type. i.e text field, textarea, checkbox, radio or dropdown."
                                    placement="right"
                                  >
                                    <em
                                      className="icon ni ni-info"
                                      style={{
                                        color: "#6576ff",
                                      }}
                                    ></em>
                                  </Tooltip>{" "}
                                  Answer Type{" "}
                                  <span className="text-danger">*</span>
                                </label>
                              </div>
                              <div className="form-control-group">
                                <MutextField
                                  id="question_type"
                                  name="question_type"
                                  select
                                  label="Select Answer Type"
                                  value={this.state.question_type}
                                  onChange={this.setMarkUp}
                                  SelectProps={{
                                    native: true,
                                  }}
                                  helperText="Please select an answer type."
                                  variant="outlined"
                                  fullWidth
                                autoComplete="new-password"
                                >
                                  <option key="sets10" value="textfield">
                                    Text Field
                                  </option>
                                  <option key="sets11" value="textarea">
                                    Text Area
                                  </option>
                                  <option key="sets12" value="radio">
                                    Radio Buttons
                                  </option>
                                  <option key="sets13" value="checkbox">
                                    Checkbox
                                  </option>

                                  <option key="sets14" value="dropdown">
                                    Drop Down
                                  </option>
                                  <option key="sets15" value="label">
                                    Label
                                  </option>
                                  <option key="sets16" value="simple_text">
                                    Text Only
                                  </option>
                                  <option key="sets17" value="fileinput">
                                    File Input
                                  </option>
                                </MutextField>
                              </div>
                            </div>
                          </div>
                          {this.state.question_type !== "label" &&
                          this.state.question_type !== "simple_text" ? (
                            <div className="col-lg-6">
                              <div className="form-group">
                                <div className="form-label-group">
                                  <label className="form-label">
                                    <Tooltip
                                      title="Non-mandatory question will be optional"
                                      placement="right"
                                    >
                                      <em
                                        className="icon ni ni-info"
                                        style={{
                                          color: "#6576ff",
                                        }}
                                      ></em>
                                    </Tooltip>{" "}
                                    Is Mandatory{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                </div>
                                <div className="form-control-group">
                                  <MutextField
                                    id="isMandatory"
                                    name="isMandatory"
                                    select
                                    value={this.state.isMandatory}
                                    onChange={this.handleChange}
                                    SelectProps={{
                                      native: true,
                                    }}
                                    helperText="Is this question mandatory to answer?"
                                    variant="outlined"
                                    fullWidth
                                    required
                                  autoComplete="new-password"
                                  >
                                    <option key="0" value="0">
                                      No
                                    </option>
                                    <option key="1" value="1">
                                      Yes
                                    </option>
                                  </MutextField>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          {this.state.question_groups.length > 0 ? (
                            <div className="col-md-6">
                              <div className="form-group">
                                <div className="form-label-group">
                                  <label className="form-label">
                                    <Tooltip
                                      title="Set of questions that this question will be a part of"
                                      placement="right"
                                    >
                                      <em
                                        className="icon ni ni-info"
                                        style={{
                                          color: "#6576ff",
                                        }}
                                      ></em>
                                    </Tooltip>{" "}
                                    Group <span className="text-danger">*</span>
                                  </label>
                                </div>
                                <div className="form-control-group">
                                  <MutextField
                                    id="selected_group"
                                    name="selected_group"
                                    select
                                    value={this.state.selected_group}
                                    onChange={this.setQuestionGroup}
                                    SelectProps={{
                                      native: true,
                                    }}
                                    variant="outlined"
                                    fullWidth
                                  autoComplete="new-password"
                                  >
                                    <option value="">Select a group</option>
                                    {this.state.question_groups
                                      .filter(
                                        (group) =>
                                          group[2] === "1" && group[3] === "0"
                                      )
                                      .map((group) => (
                                        <option key={group[4]} value={group[4]}>
                                          {group[1]}
                                        </option>
                                      ))}
                                  </MutextField>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          <div className="col-lg-6">
                            <div className="form-group">
                              <div className="form-label-group">
                                <label className="form-label">
                                  <Tooltip
                                    title="Sequence number of the question"
                                    placement="right"
                                  >
                                    <em
                                      className="icon ni ni-info"
                                      style={{
                                        color: "#6576ff",
                                      }}
                                    ></em>
                                  </Tooltip>{" "}
                                  Sequence Number{" "}
                                  <span className="text-danger">*</span>
                                </label>
                              </div>
                              <div className="form-control-group">
                                <MutextField
                                  required
                                  id="seqno"
                                  name="seqno"
                                  type="text"
                                  label="Sequence Number"
                                  value={this.state.seqno}
                                  onChange={this.handleChange}
                                  HelperclassName="Number only"
                                  variant="outlined"
                                  onKeyPress={() => {
                                    this.checkNumber();
                                  }}
                                  fullWidth
                                autoComplete="new-password"
                                />
                              </div>
                            </div>
                          </div>
                          {this.state.show_container_text === true ? (
                            <>
                              <div className="col-lg-12">
                                <h6
                                  style={{
                                    borderTop: "1px solid #e5e9f2",
                                    paddingTop: "20px",
                                  }}
                                >
                                  Enter Text
                                </h6>
                              </div>
                              <div className="col-md-12">
                                <div className="col-lg-12">
                                  <div className="form-group">
                                    <RichTextEditorComponent
                                      agreementContent={
                                        this.state.misc_rows[0]
                                          ?.question_options || ""
                                      }
                                      onContentChange={this.handleEditorBank}
                                    />
                                  </div>
                                </div>
                              </div>
                            </>
                          ) : null}
                          {this.state.show_container === true ? (
                            <>
                              <div className="col-lg-12">
                                <h6
                                  style={{
                                    borderTop: "1px solid #e5e9f2",
                                    paddingTop: "20px",
                                  }}
                                >
                                  Answer Options
                                </h6>
                              </div>
                              <div className="col-md-12">
                                <div className="form-group">
                                  <table
                                    className="table table-bordered"
                                    id="tab_logic"
                                  >
                                    <thead className="thead-light">
                                      <tr>
                                        <th style={{ lineHeight: "28px" }}>
                                          {" "}
                                          Answers{" "}
                                        </th>

                                        <th className="text-center">
                                          {this.state.misc_rows.length < 5 ? (
                                            <span
                                              className="badge badge-outline-success"
                                              onClick={this.handleAddRow}
                                              style={{
                                                cursor: "pointer",
                                                paddingTop: "3px",
                                                paddingBottom: "3px",
                                                paddingLeft: "7px",
                                                fontSize: "18px",
                                              }}
                                            >
                                              <em className="icon ni ni-plus"></em>
                                            </span>
                                          ) : null}
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {this.state.misc_rows.map((item, idx) => (
                                        <tr id={`addr${idx}`} key={`idx${idx}`}>
                                          <td
                                            style={{
                                              paddingTop: "20px",
                                            }}
                                          >
                                            <MutextField
                                              id="question_options"
                                              name="question_options"
                                              label="Answer Option"
                                              defaultValue={
                                                this.state.misc_rows[idx]
                                                  .question_options
                                              }
                                              variant="outlined"
                                              onChange={this.handleChangeMisc(
                                                idx
                                              )}
                                              fullWidth
                                            autoComplete="new-password"
                                            />
                                          </td>

                                          <td
                                            className="text-center"
                                            style={{
                                              paddingTop: "20px",
                                            }}
                                          >
                                            <span
                                              className="badge badge-outline-danger"
                                              onClick={this.handleRemoveSpecificRow(
                                                idx
                                              )}
                                              style={{
                                                cursor: "pointer",
                                                paddingTop: "3px",
                                                paddingBottom: "3px",
                                                paddingLeft: "7px",
                                                fontSize: "18px",
                                              }}
                                            >
                                              <em className="icon ni ni-trash"></em>
                                            </span>
                                          </td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </>
                          ) : null}
                          <div className="col-md-12 text-right">
                            {this.state.button_processing === true ? (
                              <button
                                className="btn btn-lg btn-primary"
                                type="button"
                                disabled
                              >
                                <span
                                  className="spinner-border spinner-border-sm"
                                  role="status"
                                  aria-hidden="true"
                                ></span>
                                <span> Loading... </span>
                              </button>
                            ) : (
                              <>
                                <a
                                  onClick={() =>
                                    this.addMenuHistory("/QuestionsLibrary")
                                  }
                                  className="btn btn-lg btn-light"
                                  disabled={this.state.disabled}
                                  style={{ marginRight: "15px" }}
                                >
                                  <em className="icon ni ni-step-back"></em>
                                  Back
                                </a>
                                <button
                                  type="button"
                                  onClick={() => this.editRfqQuestion()}
                                  className="btn btn-lg btn-primary"
                                  disabled={this.state.disabled}
                                ><em className="icon ni ni-save"></em>{" "}
                                      &nbsp;
                                  Save Question
                                </button>
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Table 5th Col End */}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    defaultSettings: state.settings,
    is_msa_signed: state.is_msa_signed,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    addSettings: (payload) => dispatch(addSettings(payload)),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddQuestionsLibrary);
